/* PackRush — card add-to-cart, qty steppers, tabs, spotlight gallery, notify dialog. */
(function () {
  'use strict';

  /* Pause animations in sections that are off-screen */
  function watchOffscreen() {
    if (!('IntersectionObserver' in window)) return;
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('pr-off', !en.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    document.querySelectorAll('.pr-cosmic, .pr-hero, .pr-sets, .pr-news, .pr-pagehead, .pr-footer__trust').forEach(function (el) {
      if (!el.dataset.prWatch) { el.dataset.prWatch = '1'; io2.observe(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchOffscreen); else watchOffscreen();
  document.addEventListener('shopify:section:load', watchOffscreen);

  /* Scroll reveal */
  document.documentElement.classList.add('pr-js');
  function reveal() {
    var els = document.querySelectorAll('.pr-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  document.addEventListener('shopify:section:load', reveal);

  function cartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* Qty steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pr-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var max = parseInt(input.max, 10) || 99;
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.prQty, 10);
    input.value = Math.min(Math.max(next, 1), max);
  });

  /* Card add-to-cart (AJAX, opens the cart drawer) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pr-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var cart = cartDrawer();
    var body = {
      items: [{ id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) || 1 }]
    };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          btn.textContent = res.description || 'Sold out';
          setTimeout(function () { btn.textContent = label; }, 2500);
          return;
        }
        document.dispatchEvent(new CustomEvent('packrush:cart:added', { detail: res }));
        if (cart && typeof cart.renderContents === 'function' && res.sections) {
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* Spotlight "Buy now": add, then straight to checkout */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pr-buynow]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); window.location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; });
  });

  /* Card sliders (prev / next) */
  function syncSlider(root) {
    var track = root.querySelector('[data-pr-track]');
    var prev = root.querySelector('[data-pr-prev]');
    var next = root.querySelector('[data-pr-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
    root.querySelector('.pr-sliderbtns').hidden = max <= 0;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pr-prev],[data-pr-next]');
    if (!b) return;
    var root = b.closest('[data-pr-slider]');
    var track = root.querySelector('[data-pr-track]');
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
    track.scrollBy({ left: b.hasAttribute('data-pr-next') ? step : -step, behavior: 'smooth' });
  });
  function initSliders() {
    document.querySelectorAll('[data-pr-slider]').forEach(function (root) {
      var track = root.querySelector('[data-pr-track]');
      if (!track || track.dataset.bound) return;
      track.dataset.bound = '1';
      track.addEventListener('scroll', function () { syncSlider(root); }, { passive: true });
      window.addEventListener('resize', function () { syncSlider(root); });
      syncSlider(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSliders); else initSliders();
  document.addEventListener('shopify:section:load', initSliders);

  /* Tabs */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.pr-tabs__tab');
    if (!tab) return;
    var root = tab.closest('[data-pr-tabs]');
    root.querySelectorAll('.pr-tabs__tab').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        if (on) panel.querySelectorAll('.pr-reveal').forEach(function (el) { el.classList.add('is-in'); });
      }
    });
  });

  /* Spotlight gallery */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-pr-thumb]');
    if (!th) return;
    var g = th.closest('[data-pr-gallery]');
    var i = th.dataset.prThumb;
    g.querySelectorAll('[data-pr-slide]').forEach(function (s) { s.hidden = s.dataset.prSlide !== i; });
    g.querySelectorAll('[data-pr-thumb]').forEach(function (t) {
      if (t === th) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  });

  /* Notify-me dialog */
  var dlg = document.getElementById('PrNotify');
  document.addEventListener('click', function (e) {
    var n = e.target.closest('[data-pr-notify]');
    if (n && dlg) {
      dlg.querySelector('[data-pr-notify-name]').textContent = n.dataset.prNotify;
      dlg.querySelector('[data-pr-notify-body]').value =
        'Back in stock request: ' + n.dataset.prNotify + ' - ' + n.dataset.prUrl;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      return;
    }
    if (dlg && (e.target.closest('[data-pr-notify-close]') || e.target === dlg)) dlg.close();
  });
  if (dlg && /contact_posted=true/.test(window.location.search) && window.location.hash === '#PrNotifyForm') {
    if (typeof dlg.showModal === 'function') dlg.showModal();
  }
})();
